export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.15-1145.35",
  commitId: "433a2407cd2066bfd4d4c241fa09d1497c41152e",
  commitTime: "2026-09-15T11:45:35.000Z",
});
